module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic.170bfb94.woff";